import { useState } from 'react';
import { toast } from 'react-toastify';
import styled from '@emotion/styled';
import { Icon, Styles } from 'toolkit/components';

const CsvDownloadBox = styled('div')`
  border: 1px solid ${Styles.colors.grey.secondaryDark};
  padding: 2px 0;
  margin-top: ${(props: { margin: string }) => props.margin};
  position: absolute;
  width: 125px;
  z-index: 1;
  &:hover {
    background-color: ${Styles.colors.blue.secondary};
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
`;

const CsvDownloadText = styled('a')`
  padding: 0.5rem;
  font-weight: bold;
  font-size: 12px;
`;

interface CsvDownloadButtonProps {
  csvLink: string;
  downloadBoxMargin?: string;
}

const CsvDownloadButton = ({ csvLink, downloadBoxMargin = '1px' }: CsvDownloadButtonProps) => {
  const [csvVisibility, setCsvVisibility] = useState(false);

  const Button = () => {
    const csvOnClick = () => {
      toast.success('Your csv is processing...');
      setCsvVisibility(!csvVisibility);
    };

    return (
      <CsvDownloadBox margin={downloadBoxMargin}>
        <CsvDownloadText href={csvLink} onClick={() => csvOnClick()}>
          Download CSV
        </CsvDownloadText>
      </CsvDownloadBox>
    );
  };

  return (
    <>
      <Icon
        type="ellipsis-v"
        color={Styles.colors.blue.secondaryDark}
        style={{ cursor: 'pointer' }}
        onClick={() => setCsvVisibility(!csvVisibility)}
      />
      {csvVisibility ? <Button /> : null}
    </>
  );
};

export default CsvDownloadButton;
